"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRANSLATION = exports.TEXT_TYPE = exports.SUBTITLE_POSITION = exports.COLUMNS = exports.COLOR = exports.CELL_TYPE = exports.ALIGNMENT = void 0;
var TRANSLATION = {
  date: 'Date',
  hotel: 'hotel',
  CheckIn: 'CheckIn',
  checkOut: 'checkOut',
  orderNumber: 'Order number',
  status: 'Status'
};
exports.TRANSLATION = TRANSLATION;
var TEXT_TYPE = {
  small: {
    fontFamily: 'default',
    fontSize: 'small',
    fontWeight: 'medium',
    lineHeight: 'XLarge',
    fontColor: 'greyDarker'
  },
  title: {
    fontFamily: 'default',
    fontSize: 'normal',
    fontWeight: 'medium',
    lineHeight: 'XLarge',
    fontColor: 'greyDarker'
  },
  text: {
    fontFamily: 'default',
    fontSize: 'normal',
    fontWeight: 'normal',
    lineHeight: 'XLarge',
    fontColor: 'neutral'
  },
  subtitle: {
    fontFamily: 'default',
    fontSize: 'XSmall',
    fontWeight: 'normal',
    lineHeight: 'XLarge',
    fontColor: 'greyDark'
  },
  bookingTitle: {
    fontFamily: 'secondary',
    fontSize: 'normal',
    fontWeight: 'normal',
    lineHeight: 'normal',
    fontColor: 'secondary'
  }
};
exports.TEXT_TYPE = TEXT_TYPE;
var COLUMNS = {
  date: 'Date',
  hotel: 'hotel',
  CheckIn: 'CheckIn',
  checkOut: 'checkOut',
  orderNumber: 'Order number',
  status: 'Status'
};
exports.COLUMNS = COLUMNS;
var SUBTITLE_POSITION = {
  prefix: 'Prefix',
  postfix: 'Postfix',
  bottom: 'Bottom'
};
exports.SUBTITLE_POSITION = SUBTITLE_POSITION;
var ALIGNMENT = {
  right: 'right',
  left: 'left',
  center: 'center'
};
exports.ALIGNMENT = ALIGNMENT;
var CELL_TYPE = {
  simple: 'simple',
  pair: 'pair',
  label: 'label',
  action: 'action',
  hotel: 'hotel'
};
exports.CELL_TYPE = CELL_TYPE;
var COLOR = {
  neutral: 'neutral',
  greyDark: 'greyDark'
};
exports.COLOR = COLOR;